<template>
  <div class="grid grid-cols-5 gap-8">
    <div class="h-[104px] w-[104px] shadow-md rounded flex justify-center items-center">shadow-md</div>
    <div class="h-[104px] w-[104px] shadow-lg rounded flex justify-center items-center">shadow-lg</div>
    <div class="h-[104px] w-[104px] shadow-xl rounded flex justify-center items-center">shadow-xl</div>
    <div class="h-[104px] w-[104px] shadow-1xl rounded flex justify-center items-center">shadow-1xl</div>
    <div class="h-[104px] w-[104px] shadow-2xl rounded flex justify-center items-center">shadow-2xl</div>
    <div class="h-[104px] w-[104px] shadow-inner rounded flex justify-center items-center">shadow-inner</div>
  </div>
</template>
